<script setup lang="ts">
const emit = defineEmits(["close"]);
const { createAuthAttemptAndRedirect } = useAuthController();
const { toaster } = useToaster();
const route = useRoute();
const router = useRouter();

const handleClose = () => {
  const query = { ...route.query };
  delete query.cause;
  router.replace({ query });
  emit("close");
};

const openOAuth = (type: string) => {
  createAuthAttemptAndRedirect(type);
  handleClose();
};

onMounted(() => {
  toaster("warn", "sessionExpired");
});
</script>
<template>
  <BaseLayoutModal width="medium" @close="handleClose">
    <template #header>
      {{ $t("main.modalTokenExpired.automaticSignOut") }}
    </template>
    <template #content>
      <div class="flex flex-col gap-2">
        <p class="text-neutral-200 font-bold">
          {{ $t("main.modalTokenExpired.yourSessionHasExpired") }}
        </p>
        <p class="text-neutral-300">
          {{ $t("main.modalTokenExpired.forSecurityReasons") }}
        </p>
        <p class="text-neutral-300">
          {{ $t("main.modalTokenExpired.clickBackToLogin") }}
        </p>
      </div>
      <div class="mt-5 mb-2 sm:mt-6 flex gap-2">
        <BaseButtonSubmit
          @click="openOAuth('login')"
          :text="$t('main.modalForcedLogout.backToLoginButton')"
          data-test="button-back-to-login-from-token-expired" />

        <BaseButtonCancel
          :text="$t('main.modalForcedLogout.close')"
          data-test="button-cancel-token-expired"
          @click="handleClose" />
      </div>
    </template>
  </BaseLayoutModal>
</template>
